module.exports = __webpack_public_path__ + "img/296.534f21f0.png";